import { VARIABLES_MODELE, modele, variablesDuTexte, type CodeModele } from './contrat.js';

export type CodeControle = 'mandant_nomme' | 'vouvoiement' | 'signature' | 'variable_inconnue' | 'emoji';

export interface Controle {
  code: CodeControle;
  message: string;
  bloquant: true;
}

export interface EntreeControle {
  code: CodeModele;
  corps: string;
  /** Noms propres du mandant à refuser en clair dans un modèle destiné à la famille. */
  nomsInterdits?: readonly string[];
}

const TUTOIEMENT = /(?<![\p{L}])(tu|toi|ton|ta|tes|t['’])(?![\p{L}])/iu;
const EMOJI = /\p{Extended_Pictographic}/u;
const SIGNATURE = /\{signature\}|Cabinet MAAT/;
const CLES_CONNUES: ReadonlySet<string> = new Set(VARIABLES_MODELE.map((v) => v.cle));

const bloquant = (code: CodeControle, message: string): Controle => ({ code, message, bloquant: true });

/** Contrôles d'un corps de modèle avant enregistrement (RG-02, UX-02). Tous sont bloquants : le modèle ne part pas. */
export function controlerModele({ code, corps, nomsInterdits = [] }: EntreeControle): Controle[] {
  const controles: Controle[] = [];
  const variables = variablesDuTexte(corps);

  if (modele(code).destinataire === 'famille') {
    const bas = corps.toLowerCase();
    const nomme = variables.includes('mandant') || nomsInterdits.some((n) => n.trim() !== '' && bas.includes(n.trim().toLowerCase()));
    if (nomme) {
      controles.push(
        bloquant(
          'mandant_nomme',
          'Ce modèle nomme le mandant. Le mandant n’est jamais nommé dans ce qui est destiné aux autres héritiers : retirez-le du texte.',
        ),
      );
    }
  }
  if (TUTOIEMENT.test(corps))
    controles.push(bloquant('vouvoiement', 'Ce modèle tutoie le destinataire. Le Cabinet MAAT vouvoie toujours.'));
  if (!SIGNATURE.test(corps))
    controles.push(bloquant('signature', 'La signature « Cabinet MAAT » manque : ajoutez {signature} en fin de message.'));
  const inconnues = [...new Set(variables.filter((v) => !CLES_CONNUES.has(v)))];
  if (inconnues.length > 0) {
    controles.push(
      bloquant('variable_inconnue', `Variable inconnue : ${inconnues.map((v) => `{${v}}`).join(', ')}. Choisissez-en une dans la liste.`),
    );
  }
  if (EMOJI.test(corps))
    controles.push(bloquant('emoji', 'Ce modèle contient un emoji. Les messages du Cabinet MAAT n’en comportent jamais.'));
  return controles;
}

export const estBloque = (controles: readonly Controle[]): boolean => controles.some((c) => c.bloquant);
